"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFileTypeInfoFromMIME = void 0;
const getFileTypeInfoFromMIME = (mime) => {
    if (!mime) {
        return {
            extension: null,
            type: null,
        };
    }
    if (mime in image_mimes) {
        return {
            type: 'image',
            extension: image_mimes[mime],
        };
    }
    if (mime in video_mimes) {
        return {
            type: 'video',
            extension: video_mimes[mime],
        };
    }
    if (mime in audio_mimes) {
        return {
            type: 'audio',
            extension: audio_mimes[mime],
        };
    }
    if (mime in pdf_mimes) {
        return {
            type: 'pdf',
            extension: pdf_mimes[mime],
        };
    }
    if (mime in misc_file_type_extensions) {
        return {
            type: 'misc',
            extension: misc_file_type_extensions[mime],
        };
    }
    return {
        type: null,
        extension: null,
    };
};
exports.getFileTypeInfoFromMIME = getFileTypeInfoFromMIME;
const image_mimes = {
    'image/bmp': 'bmp',
    'image/gif': 'gif',
    'image/jpeg': 'jpg',
    'image/png': 'png',
    'image/webp': 'webp',
    'image/x-icon': 'ico',
    'image/heic': 'heic',
};
const pdf_mimes = {
    'application/pdf': 'pdf',
};
const video_mimes = {
    'video/mp4': 'mp4',
    'video/webm': 'webm',
};
const audio_mimes = {
    'audio/mpeg': 'mp3',
    'audio/wav': 'wav',
    'audio/ogg': 'ogg',
    'audio/webm': 'webm',
};
const misc_file_type_extensions = {
    'application/octet-stream': 'bin',
    'application/postscript': 'ps',
    'application/vnd.ms-fontobject': 'eot',
    'application/x-gzip': 'gz',
    'application/x-rar-compressed': 'rar',
    'application/zip': 'zip',
    'font/ttf': 'ttf',
    'font/woff': 'woff',
    'text/html; charset=utf-8': 'html',
    'text/plain; charset=utf-16le': 'txt',
    'text/plain; charset=utf-8': 'txt',
    'text/xml; charset=utf-8': 'xml',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document': 'docx',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': 'xlsx',
    'application/vnd.openxmlformats-officedocument.presentationml.presentation': 'pptx',
    'application/vnd.ms-excel': 'xls',
    'application/vnd.ms-powerpoint': 'ppt',
    'application/vnd.ms-word': 'doc',
    'application/msword': 'doc',
    'application/pdf': 'pdf',
    'image/jpeg': 'jpg',
    'image/png': 'png',
    'image/gif': 'gif',
    'image/webp': 'webp',
    'image/x-icon': 'ico',
    'image/heic': 'heic',
    'audio/mpeg': 'mp3',
    'audio/wav': 'wav',
    'audio/ogg': 'ogg',
    'audio/webm': 'webm',
    'video/mp4': 'mp4',
    'video/webm': 'webm',
};
//# sourceMappingURL=mimes.js.map